// extracted by mini-css-extract-plugin
export default {"loading":"AlertConfirm_loading__G0ADE","buttonAcept":"AlertConfirm_buttonAcept__zO5-p","buttonCancel":"AlertConfirm_buttonCancel__R6hQp"};